
import React, { Fragment } from 'react';
import partialRight from 'lodash/partialRight';

import {
  ErrorIcon,
  SuccessIcon,
  WarningIcon,
  InfoCircleIcon
} from 'zoomforth_component_lib/app_modern_icons.jsx';

import {
  show as showNotification
} from 'react-notification-system-redux';

const show = ({ icon, graphic, message, children, ...opts }, level)=>
  showNotification({
    children: <Fragment>
      <div className="notification-icon">
        { graphic ?
            graphic
          :
            <div className="notification-icon-bg">
              {
                icon ? 
                  icon
                : level === 'error' ?
                  <ErrorIcon />
                : level === 'success' ?
                  <SuccessIcon />
                : level === 'warning' ?
                  <WarningIcon />
                : level === 'info' ?
                  <InfoCircleIcon />
                :
                  null
              }
            </div>
        }
      </div>
      <div className="notification-message">
        {children || message}
      </div>

    </Fragment>,
    ...opts
    

  }, level);

const error = partialRight(show, 'error');
const info = partialRight(show, 'info');
const success = partialRight(show, 'success');
const warning = partialRight(show, 'warning');

export {
  error,
  info,
  show,
  success,
  warning
};

export default {
  error,
  info,
  show,
  success,
  warning
};